// extracted by mini-css-extract-plugin
export default {"Rating":"Rating__1UFHx","star":"star__SfuSu","active":"active__mfUko"};